import React from 'react';
import { Node } from '@uncinc/react-drupal-core';
import useValueForCurrentViewPort from '../../../helpers/useValueForCurrentViewPort';
import i18next from '../../../config/i18next';

import {
  SliderRelated,
} from '../../../components';

import './style.scss';

const SeriesRelated = ({ entities }) => {
  const slidesToShow = useValueForCurrentViewPort(1, 1, 3, 3, 3);

  return (entities && entities.size > 0) && (
    <div className="View SeriesRelated">
      <SliderRelated slidesToShow={slidesToShow} title={i18next.t('others_also_viewed__series')}>
        {entities.map((entity) => {
          const id = entity.getIn(['nid', '0', 'value']);
          const uuid = entity.getIn(['uuid', 0, 'value']);
          const langcode = entity.getIn(['langcode', 0, 'value']);
          const className = 'SeriesRelated__item';
          return (
            <div key={`${uuid}:${langcode}`} className={className}>
              <Node
                id={id}
                key={`${uuid}:${langcode}`}
                isActivePath
                entity={entity}
                viewMode="teaser"
              />
            </div>
          );
        })}
      </SliderRelated>
    </div>
  );
};

export default SeriesRelated;
